import { Box, Button } from '@mui/material';
import { List } from 'phosphor-react';
import K2Logo from '../../../assets/images/k2-new-logo-black.png';

import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { removeClient } from '../../../store/user/user-slice';
import LayoutHeader from '../LayoutHeader';
import { Sidebar } from '../../Sidebar';
import { NavbarContainer } from '../NavbarContainer';
import ShareIcon from '../../../assets/Icons/share-icon';
import { SidebarExtensionProvider } from '../../../context/SidebarExtensionProvider/SidebarExtensionProvider';
import { useLayoutItems } from './useLayoutItems';

const Layout = () => {
  const authUser = useAppSelector(state => state.user.user);
  const client = useAppSelector(state => state.user.client);
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { sidebarItems, dropdownItems } = useLayoutItems();

  const navigateToAdmin = () => {
    navigate('/admin');
    appDispatch(removeClient());
  };

  const user = client || authUser;

  const userDetails = [
    {
      detailName: 'Personal Tax Strategies',
      detailValue: user?.personal_tax_strategies,
    },
    {
      detailName: 'Business Tax Strategies',
      detailValue: user?.business_tax_strategies,
    },
    {
      detailName: 'Financial Strategies',
      detailValue: user?.financial_tax_strategies,
    },
  ];

  const layoutHeader = (
    <LayoutHeader
      name={user?.name}
      lastname={user?.lastName}
      userDetails={userDetails}
    />
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {!!client && (
        <Button
          sx={{
            display: 'flex',
            gap: '5px',
            backgroundColor: '#52AB98',
            color: 'white',
            width: '100%',
            borderRadius: 0,
            ':hover': {
              backgroundColor: '#52AB98',
            },
          }}
          onClick={navigateToAdmin}
        >
          <ShareIcon color='#FDFDFD' />
          Admin View
        </Button>
      )}

      <NavbarContainer
        current={layoutHeader}
        mobile={
          <Box
            sx={{
              padding: '18px 32px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <List size={32} onClick={() => setIsDrawerOpen(!isDrawerOpen)} />
            <img
              src={K2Logo}
              alt='welcome-k2-logo'
              style={{ maxWidth: '64px', color: 'black' }}
            />
          </Box>
        }
      />

      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'row',
          overflowY: 'hidden',
        }}
      >
        <Sidebar
          mobileHeader={layoutHeader}
          sidebarItems={sidebarItems}
          user={authUser}
          dropdownItems={dropdownItems}
          isDrawerOpen={isDrawerOpen}
          closeDrawer={setIsDrawerOpen}
        />
        <SidebarExtensionProvider>
          <Box
            sx={{
              width: '100%',
              overflowY: 'scroll',
              overflowX: 'hidden',
              height: '100%',
              backgroundColor: '#FAFAFB',
            }}
          >
            <Outlet />
          </Box>
        </SidebarExtensionProvider>
      </Box>
    </Box>
  );
};

export default Layout;
